import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { DlpProduct } from 'state/secondaryMarket/referential/dlpProduct/dlpProduct.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export const apiConnector = (http$: IHttpClient) => ({
  loadDlpProduct(isin: string): Observable<DlpProduct | 'not_found'> {
    return http$
      .getJSON<DlpProduct>({
        url: `api/v1/secondary-market/dlp/products/${isin}`,
        expect404NotFound: true,
      })
      .pipe(
        map(({ payload }) => {
          if (payload === undefined) {
            return 'not_found';
          }
          return payload;
        }),
      );
  },
});
